module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="top-hotels__no-review">\n    <h2 class="top-hotels__heading">\n        Об этом отеле ещё никто не писал\n    </h2>\n</div>';
}
return __p;
};
